export const getCheckoutMessage = text => {
  return {
    nodes: [{
      id: 'ymnqxbmks',
      type: 'PARAGRAPH',
      paragraphData: {
        textStyle: {
          textAlignment: 'CENTER'
        }
      },
      nodes: [{
        nodes: [],
        id: '',
        type: 'TEXT',
        textData: {
          text,
          decorations: []
        }
      }]
    }],
    metadata: {
      version: 1,
      id: 'af4951a2-dd8f-44ec-b2dc-cb4c09f65ee9'
    }
  };
};
//# sourceMappingURL=checkout-message.js.map